import React, { useEffect, useState } from "react";
import useLocalization from "./useLocalization";
import toBaseLocale from "../utils/toBaseLocale";
var usePageTranslations = function() {
    var ref = useLocalization(), currentLocale = ref.currentLocale, localeLabels = ref.localeLabels, _translations = ref.translations, translations = _translations === void 0 ? [] : _translations, onChangeLocale = ref.onChangeLocale;
    var ref1 = useState(), data = ref1[0], setData = ref1[1];
    var _NEXT_PUBLIC_BASE_PATH;
    var basePath = (_NEXT_PUBLIC_BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH) !== null && _NEXT_PUBLIC_BASE_PATH !== void 0 ? _NEXT_PUBLIC_BASE_PATH : "";
    useEffect(function() {
        if (currentLocale) {
            var switcherData = {
                currentLocale: {
                    locale: toBaseLocale(currentLocale),
                    localeLabel: localeLabels[currentLocale]
                },
                translations: translations.map(function(t) {
                    return {
                        locale: toBaseLocale(t.locale),
                        localeLabel: localeLabels[t.locale],
                        url: t.url ? "".concat(basePath).concat(t.url) : undefined
                    };
                })
            };
            setData(switcherData);
        }
    }, [
        currentLocale,
        translations
    ]);
    return [
        data,
        {
            onChangeLocale: onChangeLocale
        }
    ];
};
export default usePageTranslations;
